import styled from 'styled-components';
import { theme } from '../../../../../global';

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 36px;
  border-bottom: 1px solid ${theme.colors.line};
  background-color: ${theme.colors.white};

  ol {
    gap: ${theme.spacings.s16};

    .ant-breadcrumb-separator {
      color: ${theme.colors.line};
    }

    a {
      font-family: 'Montserrat';
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      color: #53555f;

      &:hover {
        background-color: transparent;
        color: #53555f;
        font-family: Montserrat;
        text-decoration: underline;
        text-decoration-style: solid;
      }
    }
  }
`;
